



























































































































import IListCustomPaper from '@/store/models/IListCustomPaper';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';

@Component({
    components: {
        Snackbar
    }
})
export default class ListCustomPapersSelector extends Vue {
    searchListCustomPapers: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    sortBy: string = 'name';
    sortDesc: boolean = false;
    headers: any = [
        { text: 'Name', value: 'name' },
        { text: 'Actions', value: 'actions', sortable: false }
    ];
    editedIndex : number = -1;
    editedItem : IListCustomPaper = {
        id: "",
        name: "",
        idCompany: ""
    }
    defaultItem : IListCustomPaper = {
        id: "",
        name: "",
        idCompany: ""
    }

    @Prop({ type: Array, required: true })
    ListCustomPapersList !: IListCustomPaper[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];

    selectedListCustomPapers : IListCustomPaper[] = [];

    get formTitle() { return this.editedIndex === -1 ? 'New Custom Paper' : 'Edit Custom Paper'; }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    resetListCustomPapers() {
        this.selectedListCustomPapers = [];
    }

    editListCustomPaper (item: any, dbox = true) {
        this.editedIndex = this.ListCustomPapersList.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
    }

    saveListCustomPaper () {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            if (this.editedIndex > -1 || this.selectedListCustomPapers[0]) {
                this.close();
                this.$emit('editListCustomPaper', this.editedItem);
                Object.assign(this.ListCustomPapersList[this.editedIndex], this.editedItem);
            } else {
                this.selectedListCustomPapers[0] = this.editedItem;
                this.$emit('saveListCustomPaper', this.editedItem);
            }
            this.close();
        } else {
            this.$emit('showMessageWarning', 'All required fields must be filled out');
        }
    }

    deleteListCustomPaper (customPaper: IListCustomPaper) {
        this.$emit('deleteListCustomPaper', customPaper);
        this.close();
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    selectListCustomPapers(item : any) : void {
        if (!this.selectedListCustomPapers.includes(item)) {
            this.selectedListCustomPapers = [];
            this.selectedListCustomPapers = [item];
        } else {
            this.selectedListCustomPapers = [];
        }
    }
    
    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
